import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { phone, phoneHref, whatsappHref } from '../data';

export default function Location() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 items-center gap-12 px-4 md:px-6">
        <Reveal>
          <SectionLabel>Location</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            Rooted in Liverpool, Serving Across the UK
          </h2>
          <p className="mt-5 max-w-md text-[15px] md:text-base leading-relaxed text-foreground-700">
            SRM Textiles is a UK business bringing traditional Indian clothing and textiles
            closer to home — from our base in Liverpool to communities across the country.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href={phoneHref}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-50"
            >
              <i className="ri-phone-line" aria-hidden="true" />
              {phone}
            </a>
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300"
            >
              <i className="ri-whatsapp-line" aria-hidden="true" />
              WhatsApp
            </a>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="overflow-hidden rounded-lg border border-background-200">
            <iframe
              title="Map showing the location of SRM Textiles in Liverpool, England"
              src="https://maps.google.com/maps?q=86%20Eastdale%20Road%2C%20Liverpool%2C%20L15%204HW&z=14&output=embed"
              className="h-[340px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            <div className="flex items-center justify-between bg-background-50 px-6 py-4">
              <div>
                <p className="text-sm font-semibold text-foreground-950">86 Eastdale Road</p>
                <p className="text-[13px] text-foreground-600">Liverpool, England, L15 4HW</p>
              </div>
              <span className="hidden sm:inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-primary-600">
                <i className="ri-map-pin-line" aria-hidden="true" />
                Registered Office
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}